import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import termsOfServiceMd from '../../content/terms-of-service.md?raw';
import SEO from '../../components/feature/SEO';

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SEO
        title="Terms of Service – QBOVerifier Invoice Fraud Protection"
        description="Read QBOVerifier's terms of service. Understand your rights and responsibilities when using our QuickBooks invoice verification and fraud protection service."
        canonical="/terms-of-service"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'QBOVerifier Terms of Service',
          description: 'Terms of service for QBOVerifier QuickBooks invoice fraud protection.',
        }}
      />
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16" style={{ backgroundColor: '#29B3E6' }}>
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold mb-6 text-white">Terms of Service</h1>
          <p className="text-xl text-white/90">
            Please read these terms carefully before using our services.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 flex-grow bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
            <div className="markdown-content">
              <ReactMarkdown 
                remarkPlugins={[remarkGfm]}
                components={{
                  h1: ({node, ...props}) => <h1 className="text-4xl font-bold text-gray-900 mb-6 mt-8 first:mt-0" {...props} />,
                  h2: ({node, ...props}) => <h2 className="text-2xl font-semibold text-gray-900 mt-12 mb-4 first:mt-0" {...props} />,
                  h3: ({node, ...props}) => <h3 className="text-xl font-semibold text-gray-900 mt-8 mb-3" {...props} />,
                  p: ({node, ...props}) => <p className="text-gray-700 leading-relaxed mb-4" {...props} />,
                  ul: ({node, ...props}) => <ul className="list-disc list-inside space-y-2 mb-4 ml-4" {...props} />,
                  ol: ({node, ...props}) => <ol className="list-decimal list-inside space-y-2 mb-4 ml-4" {...props} />,
                  li: ({node, ...props}) => <li className="text-gray-700" {...props} />,
                  strong: ({node, ...props}) => <strong className="font-semibold text-gray-900" {...props} />,
                  a: ({node, ...props}) => <a className="text-[#29B3E6] hover:text-[#1a8bb8] hover:underline transition-colors cursor-pointer" {...props} />,
                  hr: ({node, ...props}) => <hr className="my-8 border-gray-200" {...props} />,
                  blockquote: ({node, ...props}) => <blockquote className="border-l-4 border-[#29B3E6] pl-4 italic text-gray-600 my-4" {...props} />,
                }}
              >
                {termsOfServiceMd}
              </ReactMarkdown>
            </div>
          </div>

          {/* Back to Home Link */}
          <div className="mt-12 text-center">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-[#29B3E6] hover:text-[#1a8bb8] font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}